import React from "react";
import { useRequiredParams } from "../../utils/use-required-params";
import { useGetThemesApi } from "../../api/methods/use-get-themes-api";
import { useGetCategoriesApi } from "../../api/methods/use-get-categories-api";
import { useCategoriesWithThemes } from "../../utils/use-categories-with-themes";
import { PageLoader } from "../../components/page-loader";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

export const ThemesPage: React.FC = () => {
  const { organizationId } = useRequiredParams<{ organizationId: string }>();

  const { data: themes, isLoading: isThemesLoading } = useGetThemesApi({
    organizationId: organizationId,
  });
  const { data: categories, isLoading: isCategoriesLoading } =
    useGetCategoriesApi({
      organizationId: organizationId,
    });

  const categoriesWithThemes = useCategoriesWithThemes(categories, themes);

  if (isThemesLoading || isCategoriesLoading) {
    return <PageLoader />;
  }

  return (
    <div className="container mx-auto p-6 bg-background">
      <div className="rounded-md border bg-card">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Theme</TableHead>
              <TableHead>Description</TableHead>
              <TableHead>Example</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {categoriesWithThemes.map((category) => (
              <React.Fragment key={`cat-${category.id}`}>
                <TableRow className="bg-muted/50">
                  <TableCell colSpan={3} className="font-medium text-lg">
                    {category.attributes.name}
                  </TableCell>
                </TableRow>
                {category.themes.map((theme) => (
                  <TableRow key={theme.id} className="bg-card">
                    <TableCell>{theme.attributes.name}</TableCell>
                    <TableCell>{theme.attributes.description}</TableCell>
                    <TableCell>{theme.attributes.examples}</TableCell>
                  </TableRow>
                ))}
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};
